import { Routes as NamedRoutes } from '@/routes'
import { useStytchMemberSession } from '@stytch/react/b2b'
import { Navigate, Outlet } from 'react-router-dom'

import type { FC } from 'react'

export const ProtectedRoutes: FC = () => {
	const { session, fromCache } = useStytchMemberSession()

	// If we definitively know there is no session, redirect to login
	if (!session && !fromCache) {
		return <Navigate to={NamedRoutes.Authenticate} replace />
	}

	// While the SDK revalidates from cache, avoid redirect churn
	if (!session) {
		return <div />
	}

	return <Outlet />
}
